(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bookoo-market-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bookoo-market-selector')) {
    class BookooMarketSelector extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.dialog = this.querySelector('[data-bookoo-market-dialog]');
        this.form = this.querySelector('form');
        this.countryInput = this.querySelector('[data-bookoo-market-country-input]');
        this.languageInput = this.querySelector('[data-bookoo-market-language-input]');
        this.recommendation = this.querySelector('[data-bookoo-market-recommendation]');
        this.recommendationFlag = this.querySelector('[data-bookoo-recommendation-flag]');
        this.recommendationQuestion = this.querySelector('[data-bookoo-recommendation-question]');
        this.recommendationSwitch = this.querySelector('[data-bookoo-recommendation-switch]');
        this.recommendationStay = this.querySelector('[data-bookoo-recommendation-stay]');
        this.recommendationClose = this.querySelector('[data-bookoo-recommendation-close]');
        this.directCountryButtons = [...this.querySelectorAll('[data-bookoo-market-country]')];
        this.marketUrlLinks = [...this.querySelectorAll('[data-bookoo-market-url]')];
        this.countryData = this.parseCountryData();
        this.pageScrollbarWidth = Math.max(
          0,
          window.innerWidth - document.documentElement.clientWidth
        );

        this.querySelectorAll('[data-bookoo-market-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.directCountryButtons.forEach((card) => {
          card.addEventListener('click', () => this.selectCountry(card));
        });

        this.marketUrlLinks.forEach((link) => {
          link.addEventListener('click', () => {
            this.rememberPendingPreference(this.preferenceForLink(link));
          });
        });

        this.recommendationSwitch?.addEventListener('click', () => {
          if (!this.recommendedCountry) return;
          if (this.recommendedCountry.url) {
            this.rememberPendingPreference(this.recommendedCountry);
            window.location.assign(this.recommendedCountry.url);
            return;
          }
          this.submitCountry(
            this.recommendedCountry.code,
            this.recommendedCountry.language,
            true
          );
        });

        this.recommendationStay?.addEventListener('click', () => {
          if (this.recommendedCountry) {
            this.writeTimedCookie(
              'bookoo_market_recommendation_dismissed',
              this.recommendedCountry.code,
              30
            );
          }
          this.hideRecommendation(true);
        });

        this.recommendationClose?.addEventListener('click', () => {
          if (this.recommendedCountry) {
            this.writeSessionValue(
              `bookoo_market_recommendation_closed_${this.recommendedCountry.code}`,
              'true'
            );
          }
          this.hideRecommendation(true);
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });

        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('bookoo-market-selector-is-open');
          document.documentElement.style.removeProperty('--bookoo-market-scrollbar-width');
        });

        this.markCurrentDestination();
        this.updateFlags();
        this.installMobileTrigger();
        this.positionRecommendation();
        this.reconcileManualChoice();
        this.loadRecommendation();
        [250, 1000, 2500].forEach((delay) => {
          window.setTimeout(() => this.installMobileTrigger(), delay);
        });
      }

      disconnectedCallback() {
        if (this.recommendation && !this.contains(this.recommendation)) {
          this.recommendation.remove();
        }
      }

      parseCountryData() {
        const source = this.querySelector('[data-bookoo-market-country-data]');
        if (!source) return [];

        try {
          const data = JSON.parse(source.textContent);
          const codes = Array.isArray(data.codes) ? data.codes : [];
          const names = Array.isArray(data.names) ? data.names : [];
          const markets = Array.isArray(data.markets) ? data.markets : [];

          return codes
            .map((code, index) => ({
              code: String(code || '').toUpperCase(),
              name: this.decodeHTML(names[index] || code || ''),
              market: String(markets[index] || ''),
            }))
            .filter((country) => country.code);
        } catch (error) {
          return [];
        }
      }

      decodeHTML(value) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = String(value || '');
        return textarea.value;
      }

      flagFromCode(code) {
        if (!code || code.length !== 2) return code;
        return code
          .toUpperCase()
          .split('')
          .map((character) => String.fromCodePoint(127397 + character.charCodeAt()))
          .join('');
      }

      marketsAreEquivalent(firstMarket, secondMarket) {
        const markets = [firstMarket, secondMarket].map((market) =>
          String(market || '').trim().toLowerCase()
        );
        if (!markets[0] || !markets[1]) return false;
        if (markets[0] === markets[1]) return true;
        const pair = markets.sort().join('|');
        return pair === 'global|us';
      }

      updateFlags() {
        document.querySelectorAll('[data-bookoo-market-flag]').forEach((flag) => {
          if (flag.querySelector('img, svg')) return;
          flag.textContent = this.flagFromCode(flag.dataset.countryCode);
        });
      }

      countryByCode(code) {
        const normalizedCode = String(code || '').toUpperCase();
        return this.countryData.find((country) => country.code === normalizedCode);
      }

      normalizeManualPreference(preference) {
        const country = String(preference?.country || preference?.code || '').toUpperCase();
        const market = String(
          preference?.market || this.countryByCode(country)?.market || ''
        ).trim();
        if (!country && !market) return null;
        return { country, market };
      }

      preferenceForCountry(code) {
        return this.normalizeManualPreference({ country: code });
      }

      preferenceForLink(link) {
        const country = String(link?.dataset.countryCode || '').toUpperCase();
        return this.normalizeManualPreference({
          country,
          market: link?.dataset.marketHandle || this.countryByCode(country)?.market,
        });
      }

      serializeManualPreference(preference) {
        const normalizedPreference = this.normalizeManualPreference(preference);
        return normalizedPreference ? JSON.stringify(normalizedPreference) : '';
      }

      parseManualPreference(value) {
        if (!value) return null;

        try {
          const parsedValue = JSON.parse(value);
          if (parsedValue && typeof parsedValue === 'object') {
            return this.normalizeManualPreference(parsedValue);
          }
        } catch (error) {
          return this.normalizeManualPreference({ country: value });
        }

        return null;
      }

      readManualPreference(name) {
        return this.parseManualPreference(this.timedCookieValue(name));
      }

      writeManualPreference(name, preference, days) {
        const serializedPreference = this.serializeManualPreference(preference);
        if (!serializedPreference) return;
        this.writeTimedCookie(name, serializedPreference, days);
      }

      rememberPendingPreference(preference) {
        this.writeManualPreference(
          'bookoo_market_manual_pending',
          preference,
          1 / 24
        );
      }

      manualPreferenceMatchesCurrent(preference) {
        const normalizedPreference = this.normalizeManualPreference(preference);
        if (!normalizedPreference) return false;
        const currentCountry = String(this.dataset.currentCountry || '').toUpperCase();
        const currentMarket = String(this.dataset.currentMarket || '').trim();
        if (
          normalizedPreference.country &&
          normalizedPreference.country === currentCountry
        ) return true;
        return this.marketsAreEquivalent(normalizedPreference.market, currentMarket);
      }

      directButtonForCountry(code) {
        const normalizedCode = String(code || '').toUpperCase();
        return this.directCountryButtons.find(
          (button) => button.dataset.countryCode === normalizedCode
        );
      }

      marketUrlForMarket(handle) {
        return this.marketUrlLinks.find(
          (link) =>
            !link.dataset.countryCode &&
            link.dataset.marketHandle === String(handle || '')
        );
      }

      marketUrlForCountry(code) {
        const normalizedCode = String(code || '').toUpperCase();
        return this.marketUrlLinks.find(
          (link) => String(link.dataset.countryCode || '').toUpperCase() === normalizedCode
        );
      }

      urlWithCountryContext(link, code) {
        const target = new URL(link.href, window.location.href);
        target.searchParams.set('country', String(code || '').toUpperCase());
        return target.toString();
      }

      destinationForCountry(code) {
        const normalizedCode = String(code || '').toUpperCase();
        const directButton = this.directButtonForCountry(normalizedCode);

        if (directButton) {
          return {
            code: normalizedCode,
            language: directButton.dataset.languageCode || 'en',
            market: this.countryByCode(normalizedCode)?.market || '',
            button: directButton,
          };
        }

        const directUrl = this.marketUrlForCountry(normalizedCode);
        if (directUrl) {
          return {
            code: normalizedCode,
            language: directUrl.dataset.languageCode || 'en',
            market:
              directUrl.dataset.marketHandle ||
              this.countryByCode(normalizedCode)?.market ||
              '',
            url: this.urlWithCountryContext(directUrl, normalizedCode),
          };
        }

        const country = this.countryByCode(normalizedCode);
        const marketUrl = this.marketUrlForMarket(country?.market);
        if (!country || !marketUrl) return null;

        return {
          code: normalizedCode,
          language: marketUrl.dataset.languageCode || 'en',
          market: country.market,
          url: this.urlWithCountryContext(marketUrl, normalizedCode),
        };
      }

      markCurrentDestination() {
        this.querySelectorAll('[aria-current="true"]').forEach((item) => {
          item.removeAttribute('aria-current');
        });

        const currentCountryButtons = this.directCountryButtons.filter(
          (button) => button.dataset.countryCode === this.dataset.currentCountry
        );
        const directButton = currentCountryButtons.find(
          (button) => button.dataset.languageCode === this.dataset.currentLanguage
        );
        if (directButton) {
          directButton.setAttribute('aria-current', 'true');
          return;
        }
        if (currentCountryButtons.length) return;

        const currentCountryUrls = this.marketUrlLinks.filter(
          (link) =>
            String(link.dataset.countryCode || '').toUpperCase() ===
            this.dataset.currentCountry
        );
        const directUrl = currentCountryUrls.find(
          (link) => link.dataset.languageCode === this.dataset.currentLanguage
        );
        if (directUrl) {
          directUrl.setAttribute('aria-current', 'true');
          return;
        }
        if (currentCountryUrls.length) return;

        const marketUrl = this.marketUrlForMarket(this.dataset.currentMarket);
        if (marketUrl?.dataset.languageCode === this.dataset.currentLanguage) {
          marketUrl.setAttribute('aria-current', 'true');
        }
      }

      installMobileTrigger() {
        const drawerMenu = document.querySelector('#MenuDrawer .drawer__menu[data-parent]');
        const mobileTrigger = document.querySelector(
          ".header__buttons > div[class*='lg:hidden'] [data-bookoo-market-external-trigger]"
        );
        if (!drawerMenu || !mobileTrigger || drawerMenu.querySelector('.bookoo-market-menu-entry')) return;

        const item = document.createElement('li');
        item.className = 'drawer__menu-group bookoo-market-menu-entry';
        mobileTrigger.parentElement?.classList.add('bookoo-market-trigger-placeholder');
        mobileTrigger.classList.add('bookoo-market-trigger--drawer');
        item.appendChild(mobileTrigger);
        drawerMenu.appendChild(item);
      }

      open() {
        if (!this.dialog) return;
        if (this.dialog.open) return;
        const scrollbarWidth = Math.max(
          this.pageScrollbarWidth || 0,
          0,
          window.innerWidth - document.documentElement.clientWidth
        );
        document.documentElement.style.setProperty(
          '--bookoo-market-scrollbar-width',
          `${scrollbarWidth}px`
        );
        document.documentElement.classList.add('bookoo-market-selector-is-open');
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }

      close() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function' && this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          document.documentElement.classList.remove('bookoo-market-selector-is-open');
          document.documentElement.style.removeProperty('--bookoo-market-scrollbar-width');
        }
      }

      selectCountry(card) {
        this.submitCountry(
          card.dataset.countryCode,
          card.dataset.languageCode,
          true
        );
      }

      submitCountry(countryCode, languageCode, rememberChoice) {
        if (!countryCode || !this.form || !this.countryInput || !this.languageInput) return;

        this.countryInput.value = countryCode;
        this.languageInput.value = languageCode || this.languageInput.value;

        if (rememberChoice) {
          this.rememberPendingPreference(this.preferenceForCountry(countryCode));
        }

        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      }

      positionRecommendation() {
        if (!this.recommendation) return;
        const firstHeaderSection = document.querySelector('.shopify-section-group-header-group');
        if (!firstHeaderSection?.parentNode) return;
        firstHeaderSection.parentNode.insertBefore(this.recommendation, firstHeaderSection);
      }

      readCookie(name) {
        const prefix = `${name}=`;
        const cookie = document.cookie
          .split(';')
          .map((part) => part.trim())
          .find((part) => part.startsWith(prefix));
        if (!cookie) return '';

        try {
          return decodeURIComponent(cookie.slice(prefix.length));
        } catch (error) {
          return '';
        }
      }

      timedCookieValue(name) {
        const value = this.readCookie(name);
        if (!value) return null;
        const separatorIndex = value.lastIndexOf('|');
        if (separatorIndex === -1) return null;
        const storedValue = value.slice(0, separatorIndex);
        const expiresAt = Number(value.slice(separatorIndex + 1));
        if (!storedValue || !Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
          return null;
        }
        return storedValue;
      }

      writeTimedCookie(name, value, days) {
        const expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
        const maxAge = Math.round(days * 24 * 60 * 60);
        const domain = (this.dataset.preferenceCookieDomain || '').trim();
        let cookie = `${name}=${encodeURIComponent(`${value}|${expiresAt}`)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
        if (domain) cookie += `; Domain=${domain}`;
        if (window.location.protocol === 'https:') cookie += '; Secure';
        document.cookie = cookie;
      }

      clearCookie(name) {
        const domain = (this.dataset.preferenceCookieDomain || '').trim();
        let cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
        if (domain) cookie += `; Domain=${domain}`;
        if (window.location.protocol === 'https:') cookie += '; Secure';
        document.cookie = cookie;
      }

      reconcileManualChoice() {
        const pendingChoice = this.readManualPreference(
          'bookoo_market_manual_pending'
        );
        const confirmedChoice = this.readManualPreference(
          'bookoo_market_manual_choice'
        );

        if (pendingChoice) {
          if (this.manualPreferenceMatchesCurrent(pendingChoice)) {
            this.writeManualPreference(
              'bookoo_market_manual_choice',
              pendingChoice,
              180
            );
            this.clearCookie('bookoo_market_manual_pending');
            return;
          }
          this.clearCookie('bookoo_market_manual_pending');
        }

        if (
          confirmedChoice &&
          !this.manualPreferenceMatchesCurrent(confirmedChoice)
        ) {
          this.clearCookie('bookoo_market_manual_choice');
        }
      }

      readSessionValue(key) {
        try {
          return window.sessionStorage.getItem(key);
        } catch (error) {
          return null;
        }
      }

      writeSessionValue(key, value) {
        try {
          window.sessionStorage.setItem(key, value);
        } catch (error) {
          return;
        }
      }

      async loadRecommendation() {
        if (this.dataset.recommendationEnabled !== 'true') return;
        if (window.Shopify?.designMode) return;
        const manualChoice = this.readManualPreference(
          'bookoo_market_manual_choice'
        );
        if (this.manualPreferenceMatchesCurrent(manualChoice)) return;

        const params = new URLSearchParams();
        params.set('country[enabled]', 'true');
        params.set('country[exclude]', this.dataset.currentCountry);
        params.set('language[enabled]', 'false');
        const root = window.Shopify?.routes?.root || '/';
        const endpoint = `${root}browsing_context_suggestions.json?${params.toString()}`;

        try {
          const response = await fetch(endpoint, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;
          const data = await response.json();
          const suggestion = data.suggestions?.find(
            (item) => item.parts?.country?.handle
          );
          const countryPart = suggestion?.parts?.country;
          if (!countryPart) return;

          const code = String(countryPart.handle || '').toUpperCase();
          const confidence = Number(countryPart.confidence ?? suggestion.confidence ?? 0);
          const minimumConfidence =
            Number(this.dataset.recommendationConfidence || 80) / 100;
          if (!code || code === this.dataset.currentCountry) return;
          if (!Number.isFinite(confidence) || confidence < minimumConfidence) return;
          const suggestedCountry = this.countryByCode(code);
          if (
            this.marketsAreEquivalent(
              this.dataset.currentMarket,
              suggestedCountry?.market
            )
          ) return;
          if (this.timedCookieValue('bookoo_market_recommendation_dismissed') === code) return;
          if (this.readSessionValue(`bookoo_market_recommendation_closed_${code}`)) return;

          const destination = this.destinationForCountry(code);
          if (!destination) return;
          this.showRecommendation({
            code,
            name:
              countryPart.name ||
              data.detected_values?.country?.name ||
              this.countryByCode(code)?.name ||
              code,
            language: destination.language,
            market: destination.market,
            url: destination.url || '',
          });
        } catch (error) {
          return;
        }
      }

      showRecommendation(country) {
        if (!this.recommendation) return;
        this.recommendedCountry = country;
        const questionTemplate =
          this.dataset.recommendationQuestion || 'Shopping from __COUNTRY__?';
        const switchTemplate =
          this.dataset.recommendationSwitch || 'Switch to __COUNTRY__';
        this.recommendationFlag.textContent = this.flagFromCode(country.code);
        this.recommendationQuestion.textContent = questionTemplate.replace(
          '__COUNTRY__',
          country.name
        );
        this.recommendationSwitch.textContent = switchTemplate.replace(
          '__COUNTRY__',
          country.name
        );
        this.recommendation.hidden = false;
        window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      }

      hideRecommendation(restoreFocus = false) {
        if (!this.recommendation) return;
        this.recommendation.hidden = true;
        window.requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
          if (!restoreFocus) return;
          const visibleTrigger = [
            ...document.querySelectorAll('[data-bookoo-market-external-trigger]'),
          ].find((trigger) => trigger.getClientRects().length > 0);
          const fallbackTrigger = document.querySelector(
            'button[aria-label="Site navigation"]'
          );
          (visibleTrigger || fallbackTrigger)?.focus();
        });
      }
    }

    customElements.define('bookoo-market-selector', BookooMarketSelector);
  }

  if (!window.bookooMarketSelectorTriggerReady) {
    window.bookooMarketSelectorTriggerReady = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bookoo-market-external-trigger]');
      if (!trigger) return;
      const selector = document.querySelector('bookoo-market-selector');
      if (selector && typeof selector.open === 'function') selector.open();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-annotate-module"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-interactive-annotate]';

    function getIndexValue(value) {
      if (value === undefined || value === null || value === '') {
        return null;
      }
      const parsed = Number.parseInt(value, 10);
      return Number.isFinite(parsed) ? parsed : null;
    }

    function createSvgElement(name) {
      return document.createElementNS('http://www.w3.org/2000/svg', name);
    }

    function initialize(root) {
      if (!root || root.dataset.annotateInitialized === 'true') {
        return;
      }
      root.dataset.annotateInitialized = 'true';

      let activeIndex = null;
      let resizeTimer;

      const animationDuration = Number.parseInt(root.dataset.animationDuration || '500', 10);
      const defaultActiveIndex = getIndexValue(root.dataset.defaultActive);
      const stage = root.querySelector('[data-annotate-stage]');
      const svg = root.querySelector('[data-annotate-svg]');

      function clearActiveState() {
        root.querySelectorAll('[data-index].is-active').forEach((item) => item.classList.remove('is-active'));
      }

      function drawLine() {
        if (!stage || !svg) {
          return;
        }
        svg.innerHTML = '';
        if (activeIndex === null || stage.offsetParent === null) {
          return;
        }

        const trigger = stage.querySelector(`[data-annotate-trigger][data-index="${activeIndex}"]`);
        const image = stage.querySelector('.interactive-annotate__image-target');
        if (!trigger || !image) {
          return;
        }

        const targetXPercent = Number.parseFloat(trigger.dataset.targetX || '50');
        const targetYPercent = Number.parseFloat(trigger.dataset.targetY || '50');
        const stageRect = stage.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const triggerRect = trigger.getBoundingClientRect();
        const isRight = trigger.classList.contains('interactive-annotate__block--right');

        svg.setAttribute('width', `${stageRect.width}`);
        svg.setAttribute('height', `${stageRect.height}`);
        svg.setAttribute('viewBox', `0 0 ${stageRect.width} ${stageRect.height}`);

        const startX = (isRight ? triggerRect.left : triggerRect.right) - stageRect.left;
        const startY = triggerRect.top + triggerRect.height / 2 - stageRect.top;
        const targetX = imageRect.left + (targetXPercent / 100) * imageRect.width - stageRect.left;
        const targetY = imageRect.top + (targetYPercent / 100) * imageRect.height - stageRect.top;
        const midX = isRight ? targetX + (startX - targetX) * 0.45 : startX + (targetX - startX) * 0.55;
        const accent = getComputedStyle(root).getPropertyValue('--annotate-active-color').trim() || '#2563eb';

        const path = createSvgElement('path');
        path.setAttribute('d', `M ${startX} ${startY} L ${midX} ${startY} L ${targetX} ${targetY}`);
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke', accent);
        path.setAttribute('stroke-width', '1.6');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');
        svg.appendChild(path);

        const length = path.getTotalLength();
        path.style.strokeDasharray = length;
        path.style.strokeDashoffset = length;
        path.getBoundingClientRect();
        path.style.transition = `stroke-dashoffset ${animationDuration}ms ease`;
        requestAnimationFrame(() => {
          path.style.strokeDashoffset = '0';
        });

        const ring = createSvgElement('circle');
        ring.setAttribute('cx', `${targetX}`);
        ring.setAttribute('cy', `${targetY}`);
        ring.setAttribute('r', '4');
        ring.setAttribute('fill', 'none');
        ring.setAttribute('stroke', accent);
        ring.setAttribute('stroke-width', '1.5');
        ring.setAttribute('opacity', '0.5');
        svg.appendChild(ring);

        const dot = createSvgElement('circle');
        dot.setAttribute('cx', `${targetX}`);
        dot.setAttribute('cy', `${targetY}`);
        dot.setAttribute('r', '4');
        dot.setAttribute('fill', accent);
        svg.appendChild(dot);

        if (ring.animate) {
          ring.animate(
            [{ r: 4, opacity: 0.5 }, { r: 11, opacity: 0 }],
            { duration: 1200, iterations: Infinity }
          );
        }
      }

      function setActive(index, shouldToggle) {
        if (shouldToggle && activeIndex === index) {
          activeIndex = null;
        } else {
          activeIndex = index;
        }

        clearActiveState();
        if (activeIndex !== null) {
          root.querySelectorAll(`[data-index="${activeIndex}"]`).forEach((item) => item.classList.add('is-active'));
        }
        drawLine();
      }

      function handleActivation(event) {
        const control = event.target.closest('[data-annotate-trigger], [data-annotate-mobile-control]');
        if (!control || !root.contains(control)) {
          return;
        }
        event.preventDefault();
        const index = getIndexValue(control.dataset.index);
        if (index !== null) {
          setActive(index, true);
        }
      }

      function handleKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        const control = event.target.closest('[data-annotate-trigger], [data-annotate-mobile-control]');
        if (!control || !root.contains(control)) {
          return;
        }
        event.preventDefault();
        const index = getIndexValue(control.dataset.index);
        if (index !== null) {
          setActive(index, true);
        }
      }

      root.addEventListener('click', handleActivation);
      root.addEventListener('keydown', handleKeydown);

      const image = root.querySelector('.interactive-annotate__image-target');
      const initializeActive = () => {
        if (defaultActiveIndex !== null && root.querySelector(`[data-index="${defaultActiveIndex}"]`)) {
          setActive(defaultActiveIndex, false);
        }
      };

      if (image && image.tagName === 'IMG' && !image.complete) {
        image.addEventListener('load', initializeActive, { once: true });
      } else {
        initializeActive();
      }

      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(drawLine, 100);
      });

      if (window.ResizeObserver) {
        new ResizeObserver(drawLine).observe(root);
      }
    }

    function initializeAll(container) {
      (container || document).querySelectorAll(SELECTOR).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document));
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mode-image-annotation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (!root || root.dataset.miaReady === 'true') return;
      root.dataset.miaReady = 'true';
      const tabs = root.querySelectorAll('[data-mia-tab]');
      const panels = root.querySelectorAll('[data-mia-panel]');

      function activate(index) {
        tabs.forEach((tab) => {
          const active = tab.dataset.index === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.index === index));
      }

      tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.index)));
    }

    function start(scope) {
      (scope || document).querySelectorAll('[data-mia]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => start(document));
    } else {
      start(document);
    }
    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
